import { ROUTE_PATH } from './consts';

export const createGiftSetPageUrl = giftSetId =>
  `${ROUTE_PATH.replace(':giftSetId', giftSetId)}`;
